import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Alert from "@material-ui/lab/Alert";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Chip from "@material-ui/core/Chip";
import Scrollbar from "react-scrollbars-custom";
import DepartmentDataService from "../../services/DepartmentService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0.5),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: (props) => ({
    flexGrow: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "31.2ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiAlert-root": {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(1),
      },
    },
  }),
  small: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "29ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    textAlign: "center",
  },
  item: {
    height: "350px",
    alignItems: "center",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

function DepartmentForm() {
  const classes = useStyles();

  const [loc] = React.useState(
    JSON.parse(localStorage.getItem("loc")).id || ""
  );

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDepartment({ ...department, [name]: value });
  };

  const [departmentMessage, setDepartmentMessage] = useState("");
  const initialDepartmentState = {
    id: null,
    name: "",
    parent: 1,
  };

  const [department, setDepartment] = useState(initialDepartmentState);
  const [submitted, setSubmitted] = useState(false);

  const saveDepartment = () => {
    var data = {
      name: department.name,
      parent: department.parent,
    };

    DepartmentDataService.create(data)
      .then((response) => {
        setDepartment({
          id: response.data.id,
          name: response.data.name,
          parent: response.data.parent,
        });
        setSubmitted(true);
        setDepartmentMessage(
          <Alert severity="success">Успешно добавихте отдела!</Alert>
        );
        setTimeout(() => {
          setDepartmentMessage(false);
        }, 5000);
        retrieveDepartments();
        console.log(response.data);
      })
      .catch((e) => {
        setSubmitted(true);
        setDepartmentMessage(
          <Alert severity="error">Възникна грешка. Опитайте отново!</Alert>
        );
        setTimeout(() => {
          setDepartmentMessage(false);
        }, 5000);
        console.log(e);
      });
  };

  const newDepartment = () => {
    setDepartment(initialDepartmentState);
    setSubmitted(false);
  };

  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    retrieveDepartments();
  }, []);

  const retrieveDepartments = () => {
    DepartmentDataService.adminAll()
      .then((response) => {
        setDepartments(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleDelete = (id) => {
    DepartmentDataService.remove(id)
      .then((response) => {
        setDepartmentMessage(
          <Alert severity="success">Успешно премахнахте отдела!</Alert>
        );
        console.log(response.data);
        retrieveDepartments();
        // retrieveDeletedDepartments();
        setTimeout(() => {
          setDepartmentMessage();
        }, 5000);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Card className={classes.item}>
      <AppBar position="static" elevation={0} color="primary">
        <Toolbar className="px-8">
          <Typography
            variant="subtitle1"
            color="inherit"
            className="flex-1 px-12"
          >
            Добави Отдел
          </Typography>
        </Toolbar>
      </AppBar>
      {departmentMessage}
      <CardContent>
        <Scrollbar id="RSC-Example" style={{ width: "100%", height: "55vh" }}>
          <div className="edit-form">
            <form className={classes.small}>
              <TextField
                required
                id="outlined-required name"
                label="Отдел"
                variant="outlined"
                name="name"
                value={department.name}
                onChange={handleInputChange}
                size="small"
              />
              <Button
                onClick={saveDepartment}
                variant="contained"
                color="primary"
              >
                Добави
              </Button>
            </form>
          </div>
          <div className={classes.chips}>
            {departments.map((department) => (
              <Chip
                id={department.id}
                onDelete={() => handleDelete(department.id)}
                label={department.name}
              />
            ))}
          </div>
        </Scrollbar>
      </CardContent>
    </Card>
  );
}

export default DepartmentForm;
